import { useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export const UserHeartbeat = () => {
  useEffect(() => {
    let heartbeatInterval: NodeJS.Timeout;

    const updateLastSeen = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();

        if (user) {
          await supabase
            .from('users')
            .update({ last_seen: new Date().toISOString() })
            .eq('id', user.id);
        }
      } catch (error) {
        console.error('Error updating last_seen:', error);
      }
    };

    const startHeartbeat = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        updateLastSeen();
        heartbeatInterval = setInterval(updateLastSeen, 30000);
      }
    };

    startHeartbeat();

    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) {
        updateLastSeen();
        clearInterval(heartbeatInterval);
        heartbeatInterval = setInterval(updateLastSeen, 30000);
      } else if (event === 'SIGNED_OUT') {
        clearInterval(heartbeatInterval);
      }
    });

    return () => {
      clearInterval(heartbeatInterval);
      authListener.subscription.unsubscribe();
    };
  }, []);

  return null;
};
